export default __webpack_public_path__ + "static/media/about-section-two.6b1742ae.png";